import * as React from 'react';

const SvgCasualShop = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={54} height={54} fill="none" {...props}>
    <path
      d="M48.938 28.688v20.25a3.376 3.376 0 01-3.376 3.374H8.438a3.376 3.376 0 01-3.376-3.374v-20.25M47.583 1.688H6.417a1.69 1.69 0 00-1.65 1.32l-3.08 13.867a5.061 5.061 0 005.063 5.063 5.061 5.061 0 005.063-5.063 5.061 5.061 0 005.062 5.063 5.061 5.061 0 005.063-5.063A5.061 5.061 0 0027 21.938a5.061 5.061 0 005.063-5.063 5.061 5.061 0 005.062 5.063 5.061 5.061 0 005.063-5.063 5.061 5.061 0 005.062 5.063 5.061 5.061 0 005.063-5.063L49.23 3.008a1.686 1.686 0 00-1.647-1.32zM5.063 38.813H33.75M33.75 52.313V28.686"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgCasualShop;
